import { useState, useEffect } from "react";

import HeroSection from "./HeroSection";
import CoachesSection from "./CoachesSection";
import MainCardsSection from "./MainCardsSection";
import HeyThereSection from "../../components/HeyThereSection";
import ShortConsultationSection from "./ShortConsultationSection";
import DownloadAppSection from "./DownloadAppSection";
import Snacks from "../../components/Snacks";
import Container from "../../components/Container";

const Main = () => {
  const [snacks, setSnacks] = useState({});
  useEffect(() => {
    const data = import("../influencer/snacks.json").then((data) =>
      setSnacks(data)
    );
  }, []);

  return (
    <>
      <section className="bg-white">
        <Container maxWidth={"max-w-full"} width="w-full">
          <HeroSection />
        </Container>
      </section>
      <section className="bg-white">
        <Container
          // maxWidth={
          //   "xs:max-w-full md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px]"
          // }
          width={"w-full"}
        >
          <MainCardsSection />
        </Container>
      </section>
      <section className="bg-white">
        <Container maxWidth={"max-w-full"} width="w-full">
          <CoachesSection />
        </Container>
      </section>

      <section className="bg-white">
        <Container width={"w-full"}>
          <HeyThereSection />
        </Container>
      </section>
      <section className="bg-white">
        <Container>
          <DownloadAppSection />
        </Container>
      </section>
      <section className="bg-white overflow-hidden">
        <Container width="w-full" maxWidth="">
          <ShortConsultationSection />
        </Container>
      </section>
      <section className="bg-white">
        <Container width={"w-full"}>
          <Snacks data={snacks}>
            <span className="text-black">
              Nutritionist approved, hard to find healthy snacks
            </span>
          </Snacks>
        </Container>
      </section>
    </>
  );
};

export default Main;
